<template>
  <div class="selection">
    <div
      class="selection__row"
      :class="{
        'selection__row--disabled': disabled,
        'selection__row--hovered': hovered,
      }"
      @click="toggleExpanded"
    >
      <div class="selection__square">
        <slot name="icon" />
      </div>
      <div class="selection__right">
        <div class="selection__right__inner">
          <div>
            <p>{{ title }}</p>
            <p v-html="subtitle"></p>
          </div>
          <slot name="action">
            <template v-if="$slots.expansion">
              <button
                class="selection__action"
                :aria-expanded="expanded"
                :aria-controls="`selection-expansion-${uuid}`"
              >
                <IconChevronDown aria-label="Aufklappen" v-if="!expanded" />
                <IconChevronUp aria-label="Zuklappen" v-else />
              </button>
            </template>
          </slot>
        </div>
        <p v-if="info && active" class="selection__right__info">{{ info }}</p>
        <hr v-if="divider && !expanded" />
      </div>
    </div>
    <div :id="`selection-expansion-${uuid}`">
      <slot name="expansion" v-if="expanded" />
    </div>
  </div>
</template>

<script>
import IconChevronDown from '@/components/icons/IconChevronDown.vue'
import IconChevronUp from '@/components/icons/IconChevronUp.vue'

let uuid = 0

export default {
  beforeCreate() {
    this.uuid = uuid.toString()
    uuid++
  },
  components: { IconChevronDown, IconChevronUp },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    divider: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    hovered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.open,
    }
  },
  methods: {
    toggleExpanded() {
      if (this.$slots.expansion) this.expanded = !this.expanded
    },
  },
}
</script>

<style lang="scss">
.selection {
  &__row {
    display: flex;
    cursor: pointer;
    margin: 0 -8px;
    padding: 0 8px;

    &:hover:not(&--disabled):not(.expansion),
    &:has(.selection__action:focus) {
      background-color: rgba($color-grey-light, 0.3);
      border-radius: 4px;
    }

    &--hovered {
      background-color: rgba($color-grey-light, 0.3);
      border-radius: 4px;
    }

    &--disabled {
      cursor: default;

      .selection {
        &__square {
          border-color: $color-grey-dark;
        }
        &__right__inner div p:first-of-type {
          font-weight: $font-weight-regular;
        }
      }
      .el-radio {
        display: none;
      }
    }
  }

  &__square {
    @include square-yellow;
    background-color: white;
    margin: 16px 16px 16px 0;
  }

  &__right {
    min-width: 0;
    width: 100%;

    &__inner {
      @include flex-center-align;
      justify-content: space-between;
      gap: 8px;

      div {
        margin: 16px 0;
        max-width: calc(100% - 32px);

        p:first-of-type {
          font-weight: $font-weight-bold;
        }

        p:last-of-type {
          color: $color-text-secondary;
          word-break: break-word;
        }
      }

      .link {
        @media (min-width: $breakpoint-mobile) {
          white-space: nowrap;
        }
      }
    }

    &__info {
      color: $color-text-secondary;
      margin-bottom: 14px;

      span {
        font-weight: $font-weight-medium;
      }
    }
  }
}
</style>
